import { buildOperationBaseContext as f, randomId as O } from "../datadog.helper.js";
import { withRumShim as m } from "../rum.helper.js";
var w = /^[A-Za-z0-9\-_.@$]+$/, g = (t) => typeof t?.startOperation == "function", u = (t) => m(t, g), v = (t) => {
  if (w.test(t)) return t;
  const r = `Invalid Datadog operation name "${t}". Allowed characters: letters, digits and - _ . @ $`;
  if (process.env.NODE_ENV !== "production") throw new Error(r);
  return console.warn(r), t.replace(/[^A-Za-z0-9\-_.@$]/g, "_");
}, y = (t, r = {}) => {
  const a = v(t), n = r.operationKey ?? `${a}-${O()}`, o = Date.now();
  let c = !1;
  const l = (e) => ({
    ...f(),
    ...r.context,
    ...e
  });
  u((e) => e.startOperation?.(a, {
    operationKey: n,
    description: r.description,
    context: l()
  }));
  const d = (e, i) => {
    if (c) return;
    c = !0;
    const s = l({
      ...i,
      clientDurationMs: Date.now() - o
    });
    u((p) => e(p, s));
  };
  return {
    name: a,
    key: n,
    isSettled: () => c,
    succeed: (e) => d((i, s) => i.succeedOperation?.(a, {
      operationKey: n,
      context: s
    }), e),
    fail: (e, i) => d((s, p) => s.failOperation?.(a, e, {
      operationKey: n,
      context: p
    }), {
      failureReason: e,
      ...i
    })
  };
}, _ = async (t, r, a) => {
  const n = y(t, a);
  try {
    const o = await r();
    return n.succeed(), o;
  } catch (o) {
    throw n.fail("error", { errorMessage: o instanceof Error ? o.message : String(o) }), o;
  }
};
export {
  y as beginOperation,
  v as normaliseOperationName,
  _ as trackOperation
};

//# sourceMappingURL=operations.helper.js.map